import './src/index.css';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { NativeBaseProvider, extendTheme } from 'native-base';
import React from 'react';
import 'react-native';
import { CookiesProvider } from 'react-cookie';
import { render } from 'react-dom';
import TagManager from 'react-gtm-module';

import App from './src/components/App';
import { AXLE_BUILD, GTM } from './src/config/environment';
import themeOptions from './src/newTheme';

AXLE_BUILD?.includes('production') &&
  Sentry.init({
    dsn: 'https://3b46c894dced439786c0af6f308a38e3@sentry.getcape.io/2',
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });

const breakpoints = {
  base: 0,
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1280,
};

const theme = extendTheme({
  ...themeOptions,
  breakpoints,
  fonts: {
    heading: 'InterMedium',
    body: 'InterRegular',
  },
});

const tagManagerArgs = {
  gtmId: GTM || 'REACT_APP_GTM',
};

TagManager.initialize(tagManagerArgs);

render(
    <CookiesProvider>
      <NativeBaseProvider theme={theme}>
          <App />
      </NativeBaseProvider>
    </CookiesProvider>,
  document.getElementById('root'),
);
